/* eslint-disable no-useless-escape */
/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { URL_API } from "config";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const payload = {
  name: "",
  email: "",
  password: "",
  confirmation_password: "",
}

const Validate = () => {
  const [account, setAccount] = useState(payload);
  const [recreate, setRecreate] = useState(false);
  const navigate = useNavigate();
  const token = window.location.href.split("/").pop();
  const decodedHeader = jwt_decode(token, { payload: true });

  const hasSomething = (str) => {
    if (str === "") return false;

    return true;
  }

  const hasUpper = (str) => {
    return hasSomething(str) && /[A-Z]/.test(str);
  }

  const hasLower = (str) => {
    return hasSomething(str) && /[a-z]/.test(str);
  }

  const hasNumber = (str) => {
    return hasSomething(str) && /\d/.test(str);
  }

  const hasLength = (str) => {
    return (
      hasSomething(str) &&
      /^(?=.*?[a-zA-Z])[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/.test(str)
    );
  }

  const hasSpecialCharacter = (str) => {
    return hasSomething(str) && /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str);
  }

  const checkAll = (str) => {
    return (
      hasLower(str) &&
      hasUpper(str) &&
      hasNumber(str) &&
      hasSpecialCharacter(str) &&
      hasLength(str) &&
      account.password === account.confirmation_password
    );
  }

  useEffect(() => {
    setAccount((account) => {
      return {
        ...account,
        name: decodedHeader.name,
        email: decodedHeader.email,
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const validationPassword = async () => {
    const encodedString = Buffer.from(`${account.password}:${account.confirmation_password}`).toString("base64");

    await axios.post(URL_API + `/user/validate/${token}`, null, {
      headers: {
        Password: `${encodedString}`,
      },
    })
      .then(function () {
        toast.success("Senha Cadastrada com sucesso");
        setRecreate(true);
      })
      .catch(function (error) {
        if (error?.response?.status === 403) {
          toast.error("Token expirado, solicite outro envio de e-mail");
        }
      });
  }

  const resendEmail = async () => {
    await axios.post(URL_API + `/user/recovery-password`, {
      email: account.email,
    });

    toast.success("Verifique sua caixa de Email");
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    setAccount((account) => {
      return {
        ...account,
        [name]: value,
      };
    });
  }

  return (
    <>
      <BasicLayout image={bgImage}>
        {!recreate ? (
          <Card>
            <MDBox
              variant="gradient"
              bgColor="success"
              borderRadius="lg"
              coloredShadow="success"
              mx={2}
              mt={-3}
              p={2}
              mb={1}
              textAlign="center"
            >
              <MDTypography
                variant="h4"
                fontWeight="medium"
                color="white"
                mt={1}
              >
                {decodedHeader.reset ? 'Alterar sua senha' : 'Criar sua senha'}
              </MDTypography>
            </MDBox>
            <MDBox pt={4} pb={3} px={3}>
              <MDBox component="form" role="form">
                <MDBox mb={2}>
                  <MDInput
                    type="name"
                    label="Nome"
                    name="name"
                    value={account.name}
                    onChange={handleChange}
                    fullWidth
                    disabled
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    type="email"
                    label="Email"
                    name="email"
                    value={account.email}
                    onChange={handleChange}
                    fullWidth
                    disabled
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    type="password"
                    label="Senha"
                    name="password"
                    value={account.password}
                    onChange={handleChange}
                    fullWidth
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    type="password"
                    label="Confirmar Senha"
                    name="confirmation_password"
                    value={account.confirmation_password}
                    onChange={handleChange}
                    fullWidth
                  />
                </MDBox>
                <MDBox>
                  <MDTypography variant="h6">
                    Requerimentos para senha
                  </MDTypography>
                </MDBox>
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  alignItems="flex-end"
                  flexWrap="wrap"
                >
                  <MDBox component="ul" m={0} pl={3.25} mb={{ xs: 8, sm: 0 }}>
                    <MDBox
                      component="li"
                      color="text"
                      fontSize="1.25rem"
                      lineHeight={1}
                    >
                      <MDTypography
                        variant="button"
                        color={
                          hasLength(account.password)
                            ? "success"
                            : !hasSomething(account.password)
                              ? "text"
                              : "error"
                        }
                        fontWeight="regular"
                        verticalAlign="middle"
                      >
                        Contém um minímo de 8 caracteres
                      </MDTypography>
                    </MDBox>
                    <MDBox
                      component="li"
                      color="text"
                      fontSize="1.25rem"
                      lineHeight={1}
                    >
                      <MDTypography
                        variant="button"
                        color={
                          hasUpper(account.password)
                            ? "success"
                            : !hasSomething(account.password)
                              ? "text"
                              : "error"
                        }
                        fontWeight="regular"
                        verticalAlign="middle"
                      >
                        Contém letras maiúsculas
                      </MDTypography>
                    </MDBox>
                    <MDBox
                      component="li"
                      color="text"
                      fontSize="1.25rem"
                      lineHeight={1}
                    >
                      <MDTypography
                        variant="button"
                        color={
                          hasLower(account.password)
                            ? "success"
                            : !hasSomething(account.password)
                              ? "text"
                              : "error"
                        }
                        fontWeight="regular"
                        verticalAlign="middle"
                      >
                        Contém letras minúsculas
                      </MDTypography>
                    </MDBox>
                    <MDBox
                      component="li"
                      color="text"
                      fontSize="1.25rem"
                      lineHeight={1}
                    >
                      <MDTypography
                        variant="button"
                        color={
                          hasSpecialCharacter(account.password)
                            ? "success"
                            : !hasSomething(account.password)
                              ? "text"
                              : "error"
                        }
                        fontWeight="regular"
                        verticalAlign="middle"
                      >
                        Contém caracteres especiais
                      </MDTypography>
                    </MDBox>
                    <MDBox
                      component="li"
                      color="text"
                      fontSize="1.25rem"
                      lineHeight={1}
                    >
                      <MDTypography
                        variant="button"
                        color={
                          hasNumber(account.password)
                            ? "success"
                            : !hasSomething(account.password)
                              ? "text"
                              : "error"
                        }
                        fontWeight="regular"
                        verticalAlign="middle"
                      >
                        Contém números
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>

                <MDBox mt={1}>
                  <MDButton
                    variant="gradient"
                    color="light"
                    onClick={validationPassword}
                    fullWidth
                    disabled={!checkAll(account.password)}
                  >
                    Alterar
                  </MDButton>
                </MDBox>
                <MDBox mt={3} mb={1} textAlign="center">
                  <MDTypography variant="button" color="text">
                    <MDTypography
                      onClick={resendEmail}
                      variant="button"
                      color="info"
                      fontWeight="medium"
                      textGradient
                      style={{ cursor: "pointer" }}
                    >
                      Reenviar Email
                    </MDTypography>
                  </MDTypography>
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        ) : (
          <Card>
            <MDBox
              variant="gradient"
              bgColor="success"
              borderRadius="lg"
              coloredShadow="success"
              mx={2}
              mt={-3}
              p={2}
              mb={1}
              textAlign="center"
            >
              <MDTypography
                variant="h4"
                fontWeight="medium"
                color="white"
                mt={1}
              >
                Sua senha foi atualizada
              </MDTypography>
            </MDBox>
            <MDBox pt={1} pb={3} px={3}>
              <MDBox component="form" role="form">
                <MDBox mt={3} mb={1} textAlign="center">
                  <MDButton
                    variant="gradient"
                    color="light"
                    onClick={() => navigate("/auth/login")}
                    fullWidth
                  >
                    Ir para Login
                  </MDButton>
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        )}
      </BasicLayout>
      <ToastContainer />
    </>
  );
}

export default Validate;
